
export enum ResourceStatus {
    DRAFT = 0,
    PUBLISHED = 1,
    ARCHIVED = 2
}

export enum ResourceType {
    NOTE,
    MEDIA,
    FILE
}

export interface Resource {
    id: number
    title: string
    description: any
    status: ResourceStatus
    type: ResourceType
    url: string
    file: File | null
    classroom_id: number
    collection_id: number
    last_updated: string
    removed_resource: string
}

export const createNewCollectionResource = (): Resource => ({
    id: 0,
    title: '',
    description: null,
    status: ResourceStatus.DRAFT,
    type: ResourceType.NOTE,
    url: '',
    file: null,
    classroom_id: 0,
    collection_id: 0,
    last_updated: '',
    removed_resource: '',
});

export function createResourcePayload(resource: Resource) {
    return ({
        title: resource.title,
        description: resource.description,
        status: resource.status,
        type: resource.type,
        url: resource.url,
        classroom_id: resource.classroom_id,
        collection_id: resource.collection_id
    });
}

export function updateResourcePayload(resource: Resource) {
    return ({
        id: resource.id,
        title: resource.title,
        description: resource.description,
        status: resource.status,
        type: resource.type,
        url: resource.url,
        classroom_id: resource.classroom_id,
        collection_id: resource.collection_id,
        removed_resource: resource.removed_resource || ""
    });
}
